import type { CascaderOption } from './iCascaderView'

export const optionSkeleton: CascaderOption[] = []
